import { ReactNode } from 'react';

interface PageHeadProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

export function PageHead({ title, subtitle, actions }: PageHeadProps) {
  return (
    <div className="px-6 pt-3 pb-4 bg-panel border-b border-border">
      <div className="flex items-center justify-between gap-4">
        {title && (
          <h1 className="text-[22px] font-semibold tracking-tight text-text leading-tight min-w-0 truncate">
            {title}
          </h1>
        )}
        {actions && <div className="flex gap-2 flex-shrink-0 ml-auto">{actions}</div>}
      </div>
      {subtitle && <div className="text-text-3 text-[13px] mt-1">{subtitle}</div>}
    </div>
  );
}
